const stepForm = new Vue({
    el: '#stepform',
    components: {
        'step-count': stepCount,
        'status-button-desgin': statusButtonDesign,
    },
    data: {
        step: {
            current: 1,  //最初のページ
            total: 2,  //合計step数(後ほどhtmlから変動)
        },
        showAddress: false,
    },
    mounted: function () {
        // DOM読み込み後
        this.$set(this.step, 'total', this.$refs.stepItems.childElementCount) //step数再設定

        // セレクトボタン
        $('select').wrap('<div class="select"></div>')
    },
    methods: {
        movePrev: function () {
            const stepNo = this.step.current - 1
            this.$set(this.step, 'current', stepNo)
        },
        moveNext: function () { // efo.js の方で利用
            const stepNo = this.step.current + 1
            this.$set(this.step, 'current', stepNo)
        },
        openAddress: function () {  // 郵便番号以外を入力する際に利用
            this.showAddress = true
        }
    }
})